import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { Header } from "../../../components/Header";
import { ListeningResultList } from "../components/ListeningResultList";
import {
  getPhrases,
  getStudentPhraseListeningAchievementsByCategory,
  getStudentPhraseListeningAchievementsByCategoryAndSentence,
  getStudentPhraseSpeakingAchievementsByCategory,
  getStudentPhraseSpeakingAchievementsByCategoryAndSentence,
} from "../../../reducks/phrase/operations";
import { PhraseEntity, RootEntity } from "../../../types";
import { SpeakingResultList } from "../components/SpeakingResultList";
import { PageTitle } from "../../../components/PageTitle";
import useLocationChange from "../../../utils/location";
import { clearPhraseAction } from "../../../reducks/phrase/actions";
import { Dropdown } from "../../../components/Dropdown";
import Loading from "../../../components/Loading";

type State = {
  className: string;
  parentTypeName: string;
  childTypeName: string;
};

export const PhraseCategoryResults = () => {
  const params = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (!params.class_id || !params.parent_type_id || !params.child_type_id) {
      navigate("/404");
    } else {
      dispatch(
        getStudentPhraseListeningAchievementsByCategory(
          params.class_id,
          params.parent_type_id,
          params.child_type_id
        )
      );
      dispatch(
        getStudentPhraseSpeakingAchievementsByCategory(
          params.class_id,
          params.parent_type_id,
          params.child_type_id
        )
      );
      dispatch(getPhrases(params.parent_type_id, params.child_type_id));
    }
  }, [dispatch]);

  const studentPhraseListeningAchievements = useSelector(
    (state: RootEntity) => state.phrase.studentPhraseListeningAchievements
  );

  const studentPhraseSpeakingAchievements = useSelector(
    (state: RootEntity) => state.phrase.studentPhraseSpeakingAchievements
  );

  const phrases = useSelector((state: RootEntity) => state.phrase.phrases);
  //dropdownで表示するsentence一覧
  const options = phrases.map((phrase: PhraseEntity, index: number) => {
    return (
      <option key={index + 1} value={phrase.id}>
        {phrase.sentence}
      </option>
    );
  });
  options.unshift(
    <option key={0} value="">
      全ての英文
    </option>
  );

  const isLoading = useSelector((state: RootEntity) => state.isLoading);

  const location = useLocation();
  const state = location.state as State;

  const [isListening, onClick] = useState(true);

  const onClickListening = () => {
    onClick(() => true);
  };

  const onClickSpeaking = () => {
    onClick(() => false);
  };

  // ページ遷移時にstoreからフレーズ情報を削除する
  useLocationChange(() => {
    dispatch(clearPhraseAction());
  });

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    if (!params.class_id || !params.parent_type_id || !params.child_type_id) {
      navigate("/404");
    } else {
      // valueが空文字の場合はすべての英文
      if (e.target.value === "") {
        dispatch(
          getStudentPhraseListeningAchievementsByCategory(
            params.class_id,
            params.parent_type_id,
            params.child_type_id
          )
        );
        dispatch(
          getStudentPhraseSpeakingAchievementsByCategory(
            params.class_id,
            params.parent_type_id,
            params.child_type_id
          )
        );
      } else {
        dispatch(
          getStudentPhraseListeningAchievementsByCategoryAndSentence(
            params.class_id,
            params.parent_type_id,
            params.child_type_id,
            e.target.value
          )
        );
        dispatch(
          getStudentPhraseSpeakingAchievementsByCategoryAndSentence(
            params.class_id,
            params.parent_type_id,
            params.child_type_id,
            e.target.value
          )
        );
      }
    }
  };

  return (
    <div>
      <Loading isLoading={isLoading} />
      <PageTitle title="カテゴリ別フレーズ詳細 - TiiFa LS" />
      <Header />
      <div className="teacher min-h-screen bg-e5 flex">
        <div className="w-full pc:ml-4 pc:border-l border-c pc:pl-10 pb-8">
          <div className="w-60 h-14">
            <Link
              to={`/classes/${params.class_id}/phrase/categories`}
              state={{ className: state.className }}
            >
              <div className="pl-4 ml-8 -mt-4 pt-4 w-54 h-14">
                <img
                  className="transform rotate-180 inline-block mr-2 mb-1"
                  src="/assets/icon-arrow.png"
                  alt=""
                />
                前の画面へ戻る
              </div>
            </Link>
          </div>
          <h2 className="text-2xl font-bold text-center mb-3">
            {`${state.className} フレーズ 学習状況`}
          </h2>
          <h3 className="text-xl font-bold text-center mb-3">
            {`${state.parentTypeName} ${state.childTypeName}`}
          </h3>
          <Dropdown options={options} handleChange={handleChange} />
          <ul className="flex justify-center mt-5 mb-3">
            <li
              onClick={onClickListening}
              className={
                isListening
                  ? "text-xl font-bold text-center px-8 pb-2 border-b-6 border-blue mr-24 cursor-pointer"
                  : "text-xl font-bold text-center px-8 pb-2 border-b-6 border-bc mr-24 cursor-pointer"
              }
            >
              リスニング
            </li>
            <li
              onClick={onClickSpeaking}
              className={
                isListening
                  ? "text-xl font-bold text-center px-6 pb-2 border-b-6 border-bc cursor-pointer"
                  : "text-xl font-bold text-center px-6 pb-2 border-b-6 border-blue cursor-pointer"
              }
            >
              スピーキング
            </li>
          </ul>
          {isListening ? (
            <ListeningResultList
              studentListeningAchievements={studentPhraseListeningAchievements}
            />
          ) : (
            <SpeakingResultList
              studentSpeakingAchievements={studentPhraseSpeakingAchievements}
            />
          )}
        </div>
      </div>
    </div>
  );
};
